import { useEkardoMutation } from '@netfront/ekardo-content-library';

import {
  UPDATE_CONDITION_CHECKBOX,
  UPDATE_CONDITION_RADIO,
  UPDATE_CONDITION_SLIDER,
  UPDATE_CONDITION_TEXT,
  UPDATE_CONDITION_DATE,
} from './UseUpdateCondition.graphql';

const useUpdateCondition = (options) => {
  const { mutation, onCompleted, onError, token, conditionType } = options ?? {};

  const updateConditionMutationQueryMap = {
    checkbox: UPDATE_CONDITION_CHECKBOX,
    radio: UPDATE_CONDITION_RADIO,
    slider: UPDATE_CONDITION_SLIDER,
    text: UPDATE_CONDITION_TEXT,
    calendar: UPDATE_CONDITION_DATE,
  };

  const [executeUpdateCondition, { loading: isLoading }] = useEkardoMutation({
    mutation: mutation ?? updateConditionMutationQueryMap[conditionType],
    options: {
      fetchPolicy: 'no-cache',
      onCompleted: (data) => {
        if (!onCompleted) {
          return;
        }

        const {
          questionAction: { updateCondition: updatedQuestionCondition },
        } = data;

        onCompleted({
          updatedQuestionCondition,
        });
      },
      onError,
    },
    token,
  });

  const handleUpdateCondition = ({ variables }) => {
    executeUpdateCondition({
      variables,
    });
  };

  return {
    handleUpdateCondition,
    isLoading,
  };
};

export { useUpdateCondition };
